import styled from 'styled-components'
import { CardSkeleton, CardWrapper } from '../../../../../components/Card/styles'

export const WrapperCards = styled.div``

export const StyledCard = styled.div`
  width: 100%;
  display: flex;
  height: 100%;
  margin-bottom: 16px;

  ${CardWrapper} {
    width: 100%;
  }
  ${CardSkeleton} {
    width: 100%;
  }
`
